import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const RevenueLineChart = ({ data, formatINR }) => {
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload?.length) {
      return (
        <div className="bg-card border border-border rounded-lg p-3 shadow-lg">
          <p className="text-sm font-medium text-foreground mb-2">{label}</p>
          {payload?.map((entry, index) => (
            <p key={index} className="text-xs" style={{ color: entry?.color }}>
              {entry?.name}: {formatINR(entry?.value)}
            </p>
          ))}
        </div>
      );
    }
    return null;
  };

  const formatYAxis = (value) => {
    return `₹${(value / 1000000)?.toFixed(0)}M`;
  };

  return (
    <div className="bg-card rounded-2xl p-4 md:p-6 shadow-elevation-2">
      <div className="mb-4">
        <h3 className="text-xl font-semibold text-foreground mb-1">Revenue Trends</h3>
        <p className="text-sm text-muted-foreground">Monthly revenue vs target comparison</p>
      </div>
      <div className="h-[300px] md:h-[400px]">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={data} margin={{ top: 5, right: 20, left: 10, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#E2E8F0" opacity={0.5} />
            <XAxis
              dataKey="month"
              stroke="#64748B"
              style={{ fontSize: '12px' }}
            />
            <YAxis
              stroke="#64748B"
              style={{ fontSize: '12px' }}
              tickFormatter={formatYAxis}
            />
            <Tooltip content={<CustomTooltip />} />
            <Legend
              wrapperStyle={{ fontSize: '14px' }}
              iconType="line"
            />
            <Line
              type="monotone"
              dataKey="revenue"
              stroke="#8B7EC8"
              strokeWidth={3}
              dot={{ fill: '#8B7EC8', r: 4 }}
              activeDot={{ r: 6 }}
              name="Revenue"
            />
            <Line
              type="monotone"
              dataKey="target"
              stroke="#A8C8EC"
              strokeWidth={2}
              strokeDasharray="5 5"
              dot={{ fill: '#A8C8EC', r: 3 }}
              name="Target"
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default RevenueLineChart;